import { render } from "./SuperPacmanInstallmentsView.vue?vue&type=template&id=9b745fce&scoped=true&ts=true"
import script from "./SuperPacmanInstallmentsView.vue?vue&type=script&lang=ts"
export * from "./SuperPacmanInstallmentsView.vue?vue&type=script&lang=ts"

import "./SuperPacmanInstallmentsView.vue?vue&type=style&index=0&id=9b745fce&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b745fce"]])

export default __exports__